<template>
    <el-dialog
    :visible="visible"
    :title="$t('code-lab/component/file-management/add.vue_0')"
    width="630px"
    append-to-body
    custom-class="codelab-popper add-project-popper"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :before-close="beforeClose"
    >
    <div class="container">
        <div class="top">
            <div class="button-item" @click="addProject">
                <svg-icon href="#codelab-icon-add-project" width="60" height="60"></svg-icon>
                <span class="label">{{$t("code-lab/component/file-management/add.vue_1")}}</span>
            </div>
            <div class="button-item" @click="importProject">
                <svg-icon href="#codelab-icon-import-project" width="60" height="60"></svg-icon>
                <span class="label">{{$t("code-lab/component/file-management/add.vue_3")}}</span>
            </div>
             <div class="button-item" @click="addFolder">
                <svg-icon href="#codelab-icon-add-folder" width="60" height="60"></svg-icon>
                <span class="label">{{$t("code-lab/component/file-management/mixins/mix-table-data-crud.js_0")}}</span>
            </div>
        </div>
        <h3 class="sample-list-title">{{$t("add_project_from_sample")}}</h3>
        <div class="sample-list">
            <el-scrollbar ref="scrollBar">
                 <ul>
                    <li v-for="sample in sampleList" :key="sample.projectid" @click="cloneSample(sample)" class="sample-item">
                        <project-sample :data="sample" ></project-sample>
                    </li>
                </ul>
            </el-scrollbar>
        </div>
    </div>
    </el-dialog>
</template>
<script>
import projectSample from "./project-sample.vue";
const Cookies = window.Cookies;
export default {
    name: "add-project-popper",
    props: {
        visible: Boolean,

    },
    components: {
        projectSample
    },
    data(){
        return {
            sampleList: []
        }
    },
    created(){
        this.getSampleList();
    },
    methods: {
        beforeClose(next){
            this.close();
            next();
        },
        close(){
            this.$emit("update:visible", false);
        },
        getSampleList(){
            const langCode = Cookies.get("langCode") || "zh-TW";
            this.b$.send("tool", {
                cmd: "get_sample_project_list",
                data: {
                    query: {
                        sort: "name",
                        limit: 0,
                        page: 1,
                        langCode
                    }
                }
            }, res => {
                if(res.status.code === '0' && res.data && res.data.payload){
                    this.sampleList = res.data.payload;
                } else {
                    this.sampleList = [];
                }
            })
        },
        addProject(){
            this.$emit("add-project");
            this.close();
        },
        importProject(){
            this.$emit("import-project");
            this.close();
        },
        addFolder(){
            this.$emit("add-folder");
            this.close();
        },
        cloneSample({projectId, name}){
            this.$emit("clone-sample", {projectId, name});
            this.close();
        }
    }
}
</script>
<style lang="scss">
.add-project-popper.el-dialog{
    border-radius: 4px;
    .el-dialog__header{
        background: #444444;
    }
    .el-dialog__body{
        padding: 0;
    }
    .container{
        width: 100%;
        overflow: hidden;
        .top{
            width: 100%;
            display: flex;
            padding: 24px 32px;
            justify-content: space-between;
            align-items: center;
            .button-item{
                width: 174px;
                height: 130px;
                border-radius: 8px;
                background-color: #333333;
                color: #ffffff;
                text-align: center;
                cursor: pointer;
                flex: 0 0 auto;
                &:hover{
                    box-shadow: 0 0 30px 0 rgba(0, 0, 0, 0.5);
                    background-color: #696969;
                }
                .svg-icon{
                    margin-top: 20px;
                }
                .label{
                    display: block;
                    width: 100%;
                    font-size: 14px;
                    line-height: 38px;
                }
            }
        }
        .sample-list-title{
            font-size: 18px;
            font-weight: normal;  
            color: #dadada;
            padding: 10px 32px 0 32px;
        }
        .sample-list{
            width: 100%;
            height: 240px;
            overflow: hidden;
            padding: 8px 8px 24px 8px;
            ul{
                width: 100%;
                overflow: hidden;
                .sample-item{
                    width: 269px;
                    height: 86px;
                    float: left;
                    margin: 8px 12px;
                    &:nth-child(odd){
                        margin-left: 24px;
                    }
                    &:nth-child(even){
                        margin-right: 24px;
                    }
                }
            }
        }
    }
}
</style>